import {
  useWSModalCustom,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";

export const ModalHowWeCalculateTaxRate: React.FC<
  WSModalCustomProps<void>
> = props => {
  return (
    <WSModal
      title="How we calculate your rate"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "Done",
            onClick: () => {
              props.onClose();
            }
          }
        ]
      }}
      {...props}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Our tax engine matches the IRS Form 1040-ES methodology and analyze
          multiple factors to determine your optimal withholding rate:
        </WSText.ParagraphSm>

        <WSInfoBox>
          <p>
            <b>Federal Income Tax Calculation</b>

            <ul>
              <li>Your total income minus applicable deductions</li>
              <li>Progressive tax brackets applied to your taxable income</li>
              <li>Each bracket calculated separately and summed</li>
            </ul>
          </p>

          <p>
            <b>Self-Employment Tax Calculation</b>

            <ul>
              <li>Net earnings adjustment per IRS guidelines</li>
              <li>Both Social Security and Medicare portions included</li>
              <li>Employer and employee portions accounted for</li>
            </ul>
          </p>
        </WSInfoBox>
      </WSList>
    </WSModal>
  );
};

export const useModalHowWeCalculateTaxRate = () =>
  useWSModalCustom(ModalHowWeCalculateTaxRate);
